export const getMinDistanceKadToClient = (comparisons) => {
  // Проверяем, есть ли в comparisons хотя бы один элемент с REGION === "КРД"
  const hasKrdRegion = (comparisons || []).some(
    (comparison) => comparison.productionInfo?.REGION === "КРД"
  );

  // Если регион производства — "КРД", возвращаем null
  if (hasKrdRegion) {
    return null;
  }
    const categories = ["os", "jbi", "gaz", "ner", "mix", "other"];
    const distances = (comparisons || []).flatMap((comparison) =>
      categories.flatMap((category) => {
        if (category === "jbi" && Array.isArray(comparison.delivery?.jbi?.details)) {
          return comparison.delivery.jbi.details.map(
            (group) => group.deliveryData?.data?.distanceKadToClient
          );
        }
        return [comparison.delivery?.[category]?.details?.data?.distanceKadToClient];
      })
    ).filter((d) => d !== undefined);
  
    return distances.length > 0 ? Math.min(...distances) : null;
  };